// Controls
import { ScreenReaderOnly } from "@ms/planner-generic-controls/lib/local/screenReaderOnly/ScreenReaderOnly";
import { Button, Link, Spinner, Toast, ToastBody, ToastFooter, ToastTitle, ToastTrigger } from "@fluentui/react-components";
import { Dismiss20Regular } from "@fluentui/react-icons";
// Strings
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
// Styles
import { useToastContentStyles } from "./ToastContent.styles";
// Utilities
import React from "react";
/** Presentational component for rendering toast content */ export function ToastContent({ toast }) {
    const styles = useToastContentStyles();
    // Create the action link if action exists
    const actionLink = toast.action ? /*#__PURE__*/ React.createElement(Link, {
        "data-testid": "toast-content-action-link",
        className: styles.link,
        onClick: toast.action.onClick
    }, toast.action.label) : undefined;
    // Wrap with ToastTrigger if dismissOnAction is true
    const toastAction = actionLink && toast.action?.dismissOnAction ? /*#__PURE__*/ React.createElement(ToastTrigger, null, actionLink) : actionLink;
    // Create the body content
    let bodyContent = toast.body?.content;
    if (toast.body?.onClick) {
        const linkStyle = toast.body.hideUnderline ? {
            textDecoration: "none"
        } : undefined;
        const bodyLink = /*#__PURE__*/ React.createElement(Link, {
            "data-testid": "toast-content-body-link",
            className: styles.link,
            onClick: toast.body.onClick,
            style: linkStyle
        }, toast.body.content);
        bodyContent = toast.body.dismissOnClick ? /*#__PURE__*/ React.createElement(ToastTrigger, null, bodyLink) : bodyLink;
    }
    const toastElement = /*#__PURE__*/ React.createElement(Toast, {
        "data-testid": "toast-content",
        appearance: "inverted"
    }, /*#__PURE__*/ React.createElement(ToastTitle, {
        action: /*#__PURE__*/ React.createElement(ToastTrigger, null, /*#__PURE__*/ React.createElement(Button, {
            "data-testid": "toast-content-button-dismiss-20",
            appearance: "transparent",
            className: styles.dismissButton,
            icon: /*#__PURE__*/ React.createElement(Dismiss20Regular, null),
            "aria-label": Strings.PlanHeader_MessageBar_DismissText_AriaLabel
        })),
        media: toast.intent === "progress" ? /*#__PURE__*/ React.createElement(Spinner, {
            size: "extra-tiny",
            style: {
                alignSelf: "flex-start"
            },
            "aria-label": Strings.Common_Loading
        }) : undefined
    }, toast.title), toast.body && /*#__PURE__*/ React.createElement(ToastBody, null, bodyContent), toastAction && /*#__PURE__*/ React.createElement(ToastFooter, null, toastAction));
    return toast.isHidden ? /*#__PURE__*/ React.createElement(ScreenReaderOnly, null, toastElement) : toastElement;
}
